import React, {FC, useEffect, useRef, useState} from 'react'
import {Step1} from './steps/Step1'
import {Step2} from './steps/Step2'
import {Step3} from './steps/Step3'
import axios from 'axios'
import {Formik, Form, FormikValues} from 'formik'
import {ICreateActionPlans, createActionPlansSchemas, inits} from './CreateActionPlansHelper'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {StepperComponent} from '../../../../../../../_metronic/assets/ts/components/_StepperComponent'
import {useIntl} from 'react-intl'
import {AnimaBaixo} from '../../../../../../../_metronic/assets/animation/styles'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {ActionPlans} from '../../../components/actionPlans-list/core/_models'
import {CardLoading} from '../../../../../../../_metronic/partials/widgets/loading/CardLoading'
import {useParams} from 'react-router-dom'
import moment from 'moment'
import {Skeleton} from 'primereact/skeleton'

const API_URL = process.env.REACT_APP_API_URL || 'api'
interface props {
  data?: ActionPlans
}

const Vertical: FC<props> = ({data}) => {
  //BUSCA TOKEN NO LOCALSTORAGE
  let token = localStorage.getItem('auth_storage')
  if (token) token = token.replace(/['"]+/g, '')

  const [loading, setLoading] = useState(false)
  const {uuid, uuid2} = useParams()
  const navigate = useNavigate()
  const intl = useIntl()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(createActionPlansSchemas[1])
  const [initValues] = useState<ICreateActionPlans>(inits)
  const [timeLoad, setTimeLoad] = useState(false)
  //const [parameterinit, setParameterinit] = useState<any>([])

  useEffect(() => {
    if (data?.id !== undefined) {
      getParameters()
      getFiles()
    }
    //eslint-disable-next-line
  }, [data])

  const getParameters = async () => {
    if (data?.actionPlanAlertDay) {
      let parameter = []
      for (let i = 0; i < data?.actionPlanAlertDay.length; i++) {
        const field: any = {
          value: data?.actionPlanAlertDay[i].alert_day,
          label: data?.actionPlanAlertDay[i].alert_day?.toString(),
        }
        parameter.push(field as any)
      }

      console.log('ALERT VERTICAL', parameter)
      initValues.alert_days = parameter
    }
  }

  const getFiles = async () => {
    let dado: any[] = []
    if (data?.action_plan_files)
      data?.action_plan_files.forEach((element) => {
        let file = {
          name: element.name,
          size: element.size,
        }
        dado.push(file)
      })
    console.log('ARQUIVO BANCO', dado)
    initValues.path = dado as any
  }

  // //quantidade de passos para o stepper
  const [passos, setPassos] = useState(1)
  const totalpassos = 3

  //preenche os valores do formulário
  initValues.provider_id = data?.provider_id
  initValues.description = data?.description || ''
  initValues.status = data?.status || ''

  // data?.conditioning?.conditioning_number && (initValues.conditioning?.conditioning_number = data?.conditioning?.conditioning_number)
  data?.email_responsible && (initValues.email_responsible = data?.email_responsible) //se existir email, preenche o campo
  data?.responsible && (initValues.responsible = data?.responsible) //se existir responsável, preenche o campo
  // if (data?.responsibles) {
  //   data?.responsibles[0].id && (initValues.responsible_id = [data?.responsibles[0].id]) //se existir responsável, preenche o campo
  // } else {
  //   initValues.responsible_id = [1]
  // }
  initValues.responsiblesT = data?.responsibles

  // data?.tag?.name && (initValues.tag = data?.tag?.name) //se existir tag, preenche o campo

  // //datas
  initValues.predicted_date = moment(data?.predicted_date).format('L') || ''

  initValues.conclusion_date = moment(data?.conclusion_date).format('L') || ''

  // //preenche os valores do formulário com padrão da moeda brasileira
  initValues.action_plan_cost = parseInt(data?.action_plan_cost || '0').toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  })

  const clickStep = (passo: number) => {
    if (!stepper.current) {
      return
    }
    while (stepper.current.currentStepIndex !== passo) {
      if (stepper.current.currentStepIndex > passo) {
        prevStep()
      } else {
        nextStep()
      }
    }
  }

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    //sistema de schema de validação de input do yup para cada passo
    setCurrentSchema(createActionPlansSchemas[passos - 1])

    setPassos(stepper.current.currentStepIndex - 1)
    stepper.current.goPrev()
  }

  const nextStep = () => {
    if (!stepper.current) {
      return
    }
    //sistema de schema de validação de input do yup para cada passo
    setCurrentSchema(createActionPlansSchemas[passos + 1])

    setPassos(stepper.current.currentStepIndex + 1)
    stepper.current.goNext()
  }

  //INICIO SUBMIT FORM
  const datasend = new FormData() //formdata object

  const submitStep = async (values: ICreateActionPlans, actions: FormikValues) => {
    console.log('VALORES', values)
    if (!stepper.current) {
      return
    }
    if (stepper.current.currentStepIndex !== totalpassos) {
      nextStep()
    } else {
      //insere os dados no formdata
      datasend.append('conditioning_uuid', uuid2 || '')
      datasend.append('uuid', uuid || '')
      datasend.append('description', values.description || '')
      datasend.append('status', values.status || '')
      //datasend.append('responsible', values.responsible || '')
      //datasend.append('email_responsible', values.email_responsible || '')
      //datasend.append('number_months', values.number_months?.toString() || '')
      datasend.append('provider_id', values.provider_id?.toString() || '')
      datasend.append('responsible_id[]', values.responsible_id?.toString() || '')

      //Tratamento de datas
      if (values.predicted_date) {
        datasend.append(
          'predicted_date',
          moment(values.predicted_date, 'DD/MM/YYYY').format('YYYY-MM-DD') || ''
        )
      }

      if (values.conclusion_date) {
        datasend.append(
          'conclusion_date',
          moment(values.conclusion_date, 'DD/MM/YYYY').format('YYYY-MM-DD') || ''
        )
      }
      //tratamento de dados path
      if (values.path) {
        values.path.forEach((element: any) => {
          datasend.append('path[]', element)
        })
      }

      //Tratamento de dados para alert_days
      if (values.alert_days) {
        let alertDays = values.alert_days as any

        for (let i = 0; i < alertDays.length; i++) {
          let convert: any = alertDays[i]
          if (convert.label) {
            datasend.append('alert_days[]', convert.value)
          } else {
            datasend.append('alert_days[]', convert)
          }
        }
        console.log('alert_days[]', datasend.getAll('alert_days[]'))
      }

      try {
        await axios({
          method: 'post',
          url: `${API_URL}/sga/v1/conditionings/${uuid2}/action_plans/update_action_plan/${uuid}`,
          data: datasend,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'ACTION_PLANS.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 3000,
        })
        setLoading(false)
        actions.resetForm()
        navigate(-1)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'ACTION_PLANS.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 1500,
        })
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  setTimeout(() => {
    setTimeLoad(true)
  }, 3000)

  return (
    <div
      ref={stepperRef}
      className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
      id='kt_create_account_stepper'
    >
      <AnimaBaixo>
        <div className='card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9'>
          <div className='card-body px-6 px-lg-10 px-xxl-15 py-20'>
            <div className='stepper-nav'>
              <div
                className='stepper-item current'
                data-kt-stepper-element='nav'
                data-kt-stepper-action='step'
                onClick={() => clickStep(1)}
              >
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>1</span>
                  </div>

                  <div className='stepper-label'>
                    <h3 className='stepper-title'>
                      {intl.formatMessage({id: 'ACTION_PLANS.STEP1'})}
                    </h3>
                    <div className='stepper-desc fw-bold'>
                      {intl.formatMessage({id: 'ACTION_PLANS.STEP1SUB'})}
                    </div>
                  </div>
                </div>

                <div className='stepper-line h-40px'></div>
              </div>

              <div
                className='stepper-item'
                data-kt-stepper-element='nav'
                data-kt-stepper-action='step'
                onClick={() => clickStep(2)}
              >
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>2</span>
                  </div>

                  <div className='stepper-label'>
                    <h3 className='stepper-title'>
                      {intl.formatMessage({id: 'ACTION_PLANS.STEP2'})}
                    </h3>
                    <div className='stepper-desc fw-bold'>
                      {intl.formatMessage({id: 'ACTION_PLANS.STEP2SUB'})}
                    </div>
                  </div>
                </div>

                <div className='stepper-line h-40px'></div>
              </div>

              <div
                className='stepper-item'
                data-kt-stepper-element='nav'
                data-kt-stepper-action='step'
                onClick={() => clickStep(3)}
              >
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>3</span>
                  </div>

                  <div className='stepper-label'>
                    <h3 className='stepper-title'>
                      {intl.formatMessage({id: 'ACTION_PLANS.STEP3'})}
                    </h3>
                    <div className='stepper-desc fw-bold'>
                      {intl.formatMessage({id: 'ACTION_PLANS.STEP3SUB'})}
                    </div>
                  </div>
                </div>
                <div className='stepper-line h-40px'></div>
              </div>
            </div>
          </div>
        </div>
      </AnimaBaixo>

      <div className='d-flex flex-row-fluid flex-center bg-body rounded'>
        <Formik validationSchema={currentSchema} initialValues={initValues} onSubmit={submitStep}>
          {() => (
            <Form className='py-20 w-100 w-xl-1200px px-9' noValidate id='kt_create_account_form'>
              <div className='current' data-kt-stepper-element='content'>
                {data?.id ? (
                  <Step1 />
                ) : (
                  <div className='col-12'>
                    <Skeleton className='mb-2 w-100'></Skeleton>
                    <Skeleton className='mb-2 w-100'></Skeleton>
                    <Skeleton className='mb-2 w-100'></Skeleton>
                    <Skeleton className='mb-2 w-100'></Skeleton>
                    <Skeleton className='mb-2 w-100'></Skeleton>
                    <Skeleton className='mb-2 w-100'></Skeleton>

                    <Skeleton height='10rem' className='mt-5 mb-2 w-100'></Skeleton>
                  </div>
                )}
              </div>

              <div data-kt-stepper-element='content'>{timeLoad ? <Step2 /> : <CardLoading />}</div>

              <div data-kt-stepper-element='content'>{timeLoad ? <Step3 /> : <CardLoading />}</div>

              {/* <div data-kt-stepper-element='content'>
                <Step4 />
              </div> */}

              <div className='d-flex flex-stack pt-10'>
                <div className='mr-2'>
                  <button
                    onClick={prevStep}
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr063.svg'
                      className='svg-icon-4 me-1'
                    />
                    {intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}
                  </button>
                </div>

                <div>
                  {data?.provider_id ? (
                    <button
                      type='submit'
                      className='btn btn-lg btn-primary me-3'
                      disabled={loading}
                    >
                      {!loading && (
                        <span className='indicator-label'>
                          {passos !== totalpassos && intl.formatMessage({id: 'COMMON.NEXT'})}
                          {passos === totalpassos && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                          {passos !== totalpassos && (
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr064.svg'
                              className='svg-icon-3 ms-2 me-0'
                            />
                          )}
                        </span>
                      )}
                      {loading && (
                        <span className='indicator-progress' style={{display: 'block'}}>
                          {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export {Vertical}
